import type { ServiceSlotIncrement } from '../../../graphql/types';

export const SUBTITLE_ELIGIBILITY = 'Eligibility';
export const REQUIRES_ELIGIBLE_EMAIL_FOR_GYM =
  'Gym access requires FCM-eligible email';
export const USES_FITNESS_CENTER_FOR_ELIGIBILITY =
  'Provides app access to anyone with active gym membership';
export const USES_FITNESS_CENTER_FOR_ELIGIBILITY_HELPER_TEXT =
  'Members must have an active MBO gym membership to access the Exos app. Pair with the In-App Registration feature grant to block non-members until they join the gym.';
export const USES_ELIGIBILITY_SERVICE_TYPE =
  'Gym members need a special MBO package to get app access';

export const SUBTITLE_OPT_IN_FEATURES = 'Opt-In Features';
export const USES_PERSONAL_TRAINING = 'Virtual Personal Training';
export const USES_HIGH_PERFORMANCE_COACHING = 'High-Performance Coaching';
// Note: the backend field is named `usesMboSso` for historical reasons, but this toggle
// is not SSO-related. It only controls whether MBO password reset emails are sent on sign-up.
// Do not add SSO behaviour to this flag without first auditing clients (e.g. Skanska) that
// have it enabled purely to suppress those emails.
export const USES_MBO_SSO = "Don't send MBO password reset emails on sign-up";
export const USES_CUSTOM_CHALLENGES = 'Custom Challenges';
export const SERVICE_SLOT_INCREMENT = 'Service booking start times';
export const SERVICE_SLOT_INCREMENT_HELPER_TEXT =
  'How often service appointment start times are offered. Session default uses fixed blocks of the session duration (e.g. hourly for a 60-minute session).';
// Keys are the enum's string values. The import is type-only on purpose so tests
// that mock the generated types module don't break this file at load time.
export const SERVICE_SLOT_INCREMENT_LABELS: Record<
  ServiceSlotIncrement,
  string
> = {
  session_default: 'Session default',
  fifteen_minutes: 'Every 15 minutes',
  thirty_minutes: 'Every 30 minutes',
  forty_five_minutes: 'Every 45 minutes',
  sixty_minutes: 'Every 60 minutes',
};
export const SERVICE_SLOT_INCREMENT_CHOICES = Object.entries(
  SERVICE_SLOT_INCREMENT_LABELS,
).map(([id, name]) => ({ id, name }));

export const SUBTITLE_CLIENT_OFFERINGS = 'Client Offerings';
export const COLLECTS_MEMBER_DATA = 'Employer Incentives';
export const COLLECTS_MEMBER_DATA_FOR_EEP = 'Employer Engagement Program';
export const MAX_FAMILY_MEMBERS = 'Family Sharing (number of invitations)';

export const SUBTITLE_OTHER_CONFIGS = 'Other Configs';
export const INACTIVITY_DURATION =
  'Require app users to log in again after N minutes of inactivity';

export const SUBTITLE_BIOMETRICS = 'Biometrics';
export const BIOMETRICS_ENABLED = 'Enable biometric authentication';
export const BIOMETRIC_HARD_SIGN_OUT_DURATION = 'Hard sign-out duration (days)';
export const BIOMETRIC_INACTIVITY_TIMEOUT =
  'Biometric inactivity timeout (minutes)';
export const ALLOWS_COACHES_TO_CREATE_MEMBERS =
  'Allow coaches to create new members via Coach Hub';
export const STRICT_APP_CHECK =
  'Block authentication requests from outside the app (detect jailbreaks)';
export const NEEDS_US_TO_FIX_THEIR_USERNAMES = `Force capitalization of people's names (used if client IdP sends BRAD not Brad)`;

export const SUBTITLE_IMPORT_HISTORY = 'Import History';
export const LAST_MBO_IMPORT_DATE = 'Last MBO Import';
export const LAST_FILE_IMPORT_DATE = 'Last File Import';

export const SUBTITLE_INTEGRATIONS = 'Integrations';

export const SUBTITLE_OPERATIONS = 'Operations';
export const IS_ARCHIVED = 'Is Archived';
export const IS_ARCHIVED_HELPER_TEXT = false;
export const USES_SSO = 'Is using SSO';
export const USES_SSO_HELPER_TEXT =
  'Cannot be configured from admin. Contact engineering.';
export const IS_FCM_ONLY = 'Is FCM Only';
export const IS_FCM_ONLY_HELPER_TEXT =
  'Leave OFF unless explicitly requested by the client. At FCM-Only clients, members are barred from using the Exos app.';
